<template>

    <form ref="extratoescolabox-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
                    <div class="form-group col-md-12">
                        <label for="escolaBoxId">EscolaBox</label>
                        <select v-select="{ dataitem: 'EscolaBox', default: 'Selecione' }" v-model="model.escolaBoxId" class="form-control" name="escolaBoxId" required></select>
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataGeracao">DataGeracao</label>
                        <input type="text" v-datepicker class="form-control" name="dataGeracao" v-model="model.dataGeracao" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataVencimento">DataVencimento</label>
                        <input type="text" v-datepicker class="form-control" name="dataVencimento" v-model="model.dataVencimento" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataReferenciaInicio">DataReferenciaInicio</label>
                        <input type="text" v-datepicker class="form-control" name="dataReferenciaInicio" v-model="model.dataReferenciaInicio" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataReferenciaFim">DataReferenciaFim</label>
                        <input type="text" v-datepicker class="form-control" name="dataReferenciaFim" v-model="model.dataReferenciaFim" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorLicencaUsoBox">ValorLicencaUsoBox</label>
                        <input type="text" class="form-control" name="valorLicencaUsoBox" placeholder="ValorLicencaUsoBox" v-model="model.valorLicencaUsoBox" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorUnitarioEnvioSMS">ValorUnitarioEnvioSMS</label>
                        <input type="text" class="form-control" name="valorUnitarioEnvioSMS" placeholder="ValorUnitarioEnvioSMS" v-model="model.valorUnitarioEnvioSMS" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="quantidadeSMSExcedidos">QuantidadeSMSExcedidos</label>
                        <input type="text" class="form-control" name="quantidadeSMSExcedidos" placeholder="QuantidadeSMSExcedidos" v-model="model.quantidadeSMSExcedidos" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorExcedidosEnvioSMS">ValorExcedidosEnvioSMS</label>
                        <input type="text" class="form-control" name="valorExcedidosEnvioSMS" placeholder="ValorExcedidosEnvioSMS" v-model="model.valorExcedidosEnvioSMS" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorLicencaOnMaps">ValorLicencaOnMaps</label>
                        <input type="text" class="form-control" name="valorLicencaOnMaps" placeholder="ValorLicencaOnMaps" v-model="model.valorLicencaOnMaps" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorUnitarioContratoTalk">ValorUnitarioContratoTalk</label>
                        <input type="text" class="form-control" name="valorUnitarioContratoTalk" placeholder="ValorUnitarioContratoTalk" v-model="model.valorUnitarioContratoTalk" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="quantidadeContratoTalkExcedidos">QuantidadeContratoTalkExcedidos</label>
                        <input type="text" class="form-control" name="quantidadeContratoTalkExcedidos" placeholder="QuantidadeContratoTalkExcedidos" v-model="model.quantidadeContratoTalkExcedidos" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorExcedidosContratoTalk">ValorExcedidosContratoTalk</label>
                        <input type="text" class="form-control" name="valorExcedidosContratoTalk" placeholder="ValorExcedidosContratoTalk" v-model="model.valorExcedidosContratoTalk" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="percentualDescontoLicencaUsoBox">PercentualDescontoLicencaUsoBox</label>
                        <input type="text" class="form-control" name="percentualDescontoLicencaUsoBox" placeholder="PercentualDescontoLicencaUsoBox" v-model="model.percentualDescontoLicencaUsoBox"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="percentualDescontoTotalEnvioSMS">PercentualDescontoTotalEnvioSMS</label>
                        <input type="text" class="form-control" name="percentualDescontoTotalEnvioSMS" placeholder="PercentualDescontoTotalEnvioSMS" v-model="model.percentualDescontoTotalEnvioSMS"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="percentualDescontoLicencaOnMaps">PercentualDescontoLicencaOnMaps</label>
                        <input type="text" class="form-control" name="percentualDescontoLicencaOnMaps" placeholder="PercentualDescontoLicencaOnMaps" v-model="model.percentualDescontoLicencaOnMaps"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="percentualDescontoTotalContratoTalk">PercentualDescontoTotalContratoTalk</label>
                        <input type="text" class="form-control" name="percentualDescontoTotalContratoTalk" placeholder="PercentualDescontoTotalContratoTalk" v-model="model.percentualDescontoTotalContratoTalk"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="planoServicoId">PlanoServicoId</label>
                        <input type="text" class="form-control" name="planoServicoId" placeholder="PlanoServicoId" v-model="model.planoServicoId"  />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "extratoescolabox-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "extratoescolabox-form-create",
            
            resources: {
                create: 'extratoescolabox',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

